module.exports = __webpack_public_path__ + "static/media/card-background-icon.ba7f83ef.svg";